import { WeekdayProps } from 'react-day-picker';

export const CustomWeekday: React.FC<WeekdayProps> = ({ ...props }) => {
  // eslint-disable-next-line react/prop-types
  const { children } = props;
  const day = children?.toString().split('')[0];
  return <th className={'rdp-weekday'}>{day}</th>;
};
